import { render } from "./OrderComplete.vue?vue&type=template&id=5afd8cbb"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"
script.render = render

export default script